import { render, staticRenderFns } from "./comparequarter.vue?vue&type=template&id=9dab7fbe&scoped=true&"
import script from "./comparequarter.vue?vue&type=script&lang=js&"
export * from "./comparequarter.vue?vue&type=script&lang=js&"
import style0 from "./comparequarter.vue?vue&type=style&index=0&id=9dab7fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab7fbe",
  null
  
)

export default component.exports